// Status chips for an Arive-synced loan file (ticket 134 P1). "Assign" opens
// the existing loans.assign dialog (AssignmentPicker) through `onAssign`; it is
// passed only when the viewer holds that permission.
import React from 'react';
import { Link } from 'react-router-dom';

const CHIP = 'inline-flex items-center gap-1.5 px-2 py-0.5 rounded-full text-[11px] font-semibold';

export function AriveChips({ arive, onAssign }) {
  if (!arive) return null;
  return (
    <>
      {arive.possible_duplicate_of && (
        <span className={CHIP} style={{ background: '#FEF3C7', color: '#92400E' }} data-testid="arive-chip-duplicate">
          Possible duplicate
          <Link to={`/portal/loans/${arive.possible_duplicate_of}`} className="underline" data-testid="arive-chip-duplicate-link">
            View loan
          </Link>
        </span>
      )}
      {arive.needs_assignment && (
        <span className={CHIP} style={{ background: '#FEE2E2', color: '#991B1B' }} data-testid="arive-chip-needs-assignment">
          Needs assignment
          {onAssign && (
            <button type="button" onClick={onAssign} className="underline" data-testid="arive-chip-assign">Assign</button>
          )}
        </span>
      )}
      {arive.suspended && (
        <span className={CHIP} style={{ background: '#E2E8F0', color: '#475569' }} data-testid="arive-chip-suspended">
          Suspended
        </span>
      )}
    </>
  );
}
